import React, { Component } from 'react'
import FlagSmall from '../FlagSmall'
import './_styles.scss'
import Translator from '../../../../../requests/apa/Translator'
import Utils from '../../../../../utils/Utils'
import { matchSchedule, matchInProgress, matchCompleted } from '../../../constants'
import Tag from '../Tag/Tag'
import { showModal, MODAL_MATCH_DETAIL } from '../../../../../actions/modal'
import store from '../../../../../store'
import { playmatch, getPhase2Config, sendMetricSelectContent, normalizeText, getMatchWinner, getIsFinishedMatch, getMatchName, getMatchScore, getSportsLiveFeedMiniPlayerConfig } from '../../../utils'
import { Button } from '../../../../../packages/components'
import { getLiveEvents } from '../../../../../containers/Mundial2026/services/getPolling'
import { setPendingMatchModal } from '../../../FootballMatchDetail/pendingMatchModal'
import { playFullMedia } from '../../../../../actions/playmedia'
import logger from 'src/utils/logger/logger';


/**
 * CardPartido
 * Match card component (416x192px from Figma)
 *
 * Props:
 *  - time      {string}  Match time (e.g. "20:00")
 *  - timezone  {string}  Timezone label (e.g. "ARG")
 *  - homeTeam  {object}  { flagUrl: string, name: string }
 *  - awayTeam  {object}  { flagUrl: string, name: string }
 *  - venue     {string}  Stadium + city (e.g. "Estadio Banorte, Ciudad de México")
 *  - isFocused {bool}    Whether the card has TV focus
 */
class CardPartido extends Component {
  constructor (props) {
    super(props)
    const { homeTeam, awayTeam } = props
    this.state = {
      showGoalCelebration: false,
      liveHomeScore: homeTeam && homeTeam.score !== undefined ? homeTeam.score : 0,
      liveAwayScore: awayTeam && awayTeam.score !== undefined ? awayTeam.score : 0,
      lastGoalEvent: null
    }
    this.celebrationTimer = null
    this.isPhase2Enabled = getPhase2Config()
    this._lastEventId = null
    this._pollerStopped = false
    this._pollTimerId = null
    this._notifTimerId = null
  }

  shouldStartPolling () {
    const { status, matchId } = this.props
    const config = getSportsLiveFeedMiniPlayerConfig()
    return status === matchInProgress && config && config.enabled === true && !!matchId
  }

  startPolling () {
    this._pollerStopped = false
    this._poll()
  }

  stopPolling () {
    this._pollerStopped = true
    clearTimeout(this._pollTimerId)
  }

  _poll = async () => {
    if (this._pollerStopped) return
    const { matchId } = this.props
    try {


      const data = await getLiveEvents(matchId, {
        lastEventId: this._lastEventId,
        topics: ['SCORE', 'TIMELINE']
      })

      if(this._pollerStopped) return


      if (!data) {
        logger.debug('⚠️ [POLLING] No data - reintentando en 5s')
        this._pollTimerId = setTimeout(this._poll, 5000)
        return
      }

      if (data.events && data.events.length > 0) {
        logger.debug(`🎯 [POLLING] ${data.events.length} eventos nuevos`)
        this._processEvents(data.events)
      } else {
        logger.debug('ℹ️ [POLLING] Sin eventos nuevos')
      }

      if (data.lastEventId) {
        this._lastEventId = data.lastEventId
      }

      if (data.matchStatus === matchCompleted) {
        logger.debug('🏁 [POLLING] Partido finalizado - deteniendo polling')
        this.stopPolling()
        return
      }

      const delay = data.hasMore ? 0 : (data.nextPollMs || 3000)
      logger.debug(`⏱️ [POLLING] Próximo poll en ${delay}ms`)
      this._pollTimerId = setTimeout(this._poll, delay)
    } catch (err) {
      logger.error('❌ [POLLING] Error:', err)
      if(this._pollerStopped) return
      this._pollTimerId = setTimeout(this._poll, 5000)
    }
  }

  _processEvents (events) {
    const { homeTeam } = this.props
    logger.debug('⚙️ [EVENTOS] Procesando eventos:', events)

    events.forEach((event) => {
      const payload = event.payload || {}
      if (event.eventType === 'GOAL') {
        logger.debug('⚽ [GOL NORMAL] Evento de gol detectado:', payload)
        clearTimeout(this._notifTimerId)
           this.setState((prevState) => ({
           liveHomeScore: payload.homeScore !== undefined ? payload.homeScore : prevState.liveHomeScore,
           liveAwayScore: payload.awayScore !== undefined ? payload.awayScore : prevState.liveAwayScore,
          lastGoalEvent: {
            eventType: 'GOAL',
            playerName: payload.playerName || '',
            minute: payload.minute || ''
          }
        }))
        this._notifTimerId = setTimeout(() => {
          this.setState({ lastGoalEvent: null })
        }, 5000)
      } else if (event.eventType === 'PENALTY_GOAL') {
        const isHome = homeTeam && payload.teamId === homeTeam.id
        logger.debug('🥅 [PENAL] Evento de penal detectado:', { payload, isHome })
        clearTimeout(this._notifTimerId)
        this.setState(function (prevState) {
          return {
            liveHomeScore: isHome ? prevState.liveHomeScore + 1 : prevState.liveHomeScore,
            liveAwayScore: !isHome ? prevState.liveAwayScore + 1 : prevState.liveAwayScore,
            lastGoalEvent: {
              eventType: 'PENALTY_GOAL',
              playerName: payload.playerName || '',
              minute: payload.minute || ''
            }
          }
        })
        this._notifTimerId = setTimeout(() => {
          this.setState({ lastGoalEvent: null })
        }, 5000)
      }
    })
  }

  componentDidMount () {
    // if (this.shouldStartPolling()) {
    //   this.startPolling()
    // }
  }

  componentDidUpdate (prevProps) {
    // 1) Manejo de cambio de match o status (polling)
    const matchChanged = prevProps.matchId !== this.props.matchId
    const statusChanged = prevProps.status !== this.props.status
    if (matchChanged) {
      const { homeTeam, awayTeam } = this.props
      clearTimeout(this._notifTimerId)
      this.setState({
        liveHomeScore: homeTeam && homeTeam.score !== undefined ? homeTeam.score : 0,
        liveAwayScore: awayTeam && awayTeam.score !== undefined ? awayTeam.score : 0,
        lastGoalEvent: null
      })
      this._lastEventId = null
    }
    if (matchChanged || statusChanged) {
      if (this.shouldStartPolling()) {
        this.stopPolling()
        this._lastEventId = null
        this.startPolling()
      } else {
        this.stopPolling()
      }
    }

    // 2) Manejo de goal celebration (liveEvents)
    if (prevProps.liveEvents === this.props.liveEvents) return
    const prevEvents = prevProps.liveEvents || []
    const currEvents = this.props.liveEvents || []
    // Detectar GOL nuevo comparando por ID para evitar falsos positivos cuando
    // el array se trunca al límite MAX_EVENTS (el length puede no crecer)
    const prevIds = new Set(prevEvents.map(function (e) {
      var id = e && (e.id || e.eventId || e.order)
      return id === undefined || id === null ? null : String(id)
    }).filter(Boolean))
    const hasNewGoal = currEvents.some(function (ev) {
      var eType = ev.eventType || ev.type
      var id = ev && (ev.id || ev.eventId || ev.order)
      var key = id === undefined || id === null ? null : String(id)
      return eType === 'GOAL' && key !== null && !prevIds.has(key)
    })
    if (hasNewGoal) {
      clearTimeout(this.celebrationTimer)
      if (!this.state.showGoalCelebration) this.setState({ showGoalCelebration: true })
      this.celebrationTimer = setTimeout(() => {
        this.setState({ showGoalCelebration: false })
      }, 2500)
    }
  }

  componentWillUnmount () {
    this.stopPolling()
    clearTimeout(this._notifTimerId)
    clearTimeout(this.celebrationTimer)
  }

  // Retorna el último evento notable como string para mostrar en la card
  getLastNotableEvent (events) {
    if (!Array.isArray(events) || events.length === 0) return null
    const NOTABLE_TYPES = ['GOAL', 'YELLOW_CARD', 'RED_CARD', 'SECOND_YELLOW_CARD', 'SECOND_YELLOW_RED_CARD']
    const LABELS = {
      GOAL: Translator.get('eventodeportivo_partidos_livefeed_texto_gol', 'GOL'),
      YELLOW_CARD: Translator.get('eventodeportivo_partidos_livefeed_texto_tarjetaamarilla', 'TA'),
      RED_CARD: Translator.get('eventodeportivo_partidos_livefeed_texto_tarjetaroja', 'TR'),
      SECOND_YELLOW_CARD: Translator.get('eventodeportivo_partidos_livefeed_texto_tarjetaamarilla', 'TA'),
      SECOND_YELLOW_RED_CARD: Translator.get('eventodeportivo_partidos_livefeed_texto_tarjetaroja', 'TR')
    }
    for (var i = events.length - 1; i >= 0; i--) {
      var ev = events[i]
      if (ev && NOTABLE_TYPES.indexOf(ev.type) !== -1) {
        var label = LABELS[ev.type]
        var minute = (ev.minuteDisplay !== undefined && ev.minuteDisplay !== null && ev.minuteDisplay !== '') ? ev.minuteDisplay : ev.minute
        var player = ev.player && ev.player.name ? ev.player.name : null
        var hasMinute = minute !== undefined && minute !== null && minute !== ''
        return hasMinute && player ? `${label} ${minute}' – ${player}` : label
      }
    }
    return null
  }

  getLastFocus = ()=>{
    const lastFocus = document.activeElement.getAttribute('id');
    return `#${lastFocus}`;
  }

  handleCardClick = () => {
    localStorage.setItem('lastFocusRecordPartido', this.getLastFocus());
    const { onClick, time, timezone, homeTeam, awayTeam, venue, matchId, status, date, path, liveScore } = this.props

    const mainMenuLabel = path && path.mainMenuLabel ? path.mainMenuLabel : null
    const parentTabLabel = path && path.parentTabLabel ? path.parentTabLabel : null
    const childTabLabel = path && path.childTabLabel ? path.childTabLabel : null

    // Prefer live data for status and scores so metrics reflect what the card actually showed
    const effectiveStatus = (liveScore && liveScore.matchFinished)
      ? 'COMPLETED'
      : ((status === 'FINISHED' || status === 'FINAL') ? 'COMPLETED' : status)
    const home = homeTeam || {}
    const away = awayTeam || {}
    const effectiveHomeScore = (liveScore && liveScore.homeScore !== undefined) ? liveScore.homeScore : home.score
    const effectiveAwayScore = (liveScore && liveScore.awayScore !== undefined) ? liveScore.awayScore : away.score
    const effectiveHome = (effectiveHomeScore !== undefined && effectiveHomeScore !== home.score) ? { ...home, score: effectiveHomeScore } : home
    const effectiveAway = (effectiveAwayScore !== undefined && effectiveAwayScore !== away.score) ? { ...away, score: effectiveAwayScore } : away

    const matchWinner = getMatchWinner(effectiveHome, effectiveAway)
    const isFinishedMatch = effectiveStatus === 'FINISHED' || effectiveStatus === 'COMPLETED' || effectiveStatus === 'FINAL'
    const matchName = getMatchName(homeTeam, awayTeam)
    const matchScore = getMatchScore(effectiveHome, effectiveAway)
    const match = {
      statusCard: effectiveStatus ? normalizeText(effectiveStatus) : null,
      contentId: matchId ? matchId : null,
      contentName: matchName,
      contentLocation: venue ? normalizeText(venue) : null,
      contentStartDate: date ? normalizeText(date) : null,
      finalScore: isFinishedMatch ? matchScore : null,
      matchWinner: isFinishedMatch ? matchWinner : null,
      matchTime: time
    }

    store.dispatch(showModal({
      modalType: MODAL_MATCH_DETAIL,
      modalProps: {
        matchData: {
          time,
          timezone,
          homeTeam,
          awayTeam,
          venue,
          matchId,
          status,
          path,
          match,
          lineups: this.props.lineups || null
        },
        callback: (groupId, pinAlreadyValidated) => {
          const matchDataForModal = { time, timezone, homeTeam, awayTeam, venue, matchId, status, path, match }
          const playFromDetail = (gid, pinOk) => {
            setPendingMatchModal({ matchData: matchDataForModal, callback: playFromDetail })
            store.dispatch(playFullMedia(Object.assign({
              playerstate: 'PLAYING',
              source: { videoid: gid },
              ispreview: false,
              islive: true,
              size: { top: 0, left: 0, width: 792, height: 428 },
              ispip: false,
              showEpg: false,
              filterTV: undefined,
              event: null,
              playFromCard: true,
              playFromMatchDetail: true
            }, pinOk === true ? { pinAlreadyValidated: true } : {})))
          }
          playFromDetail(groupId, pinAlreadyValidated)
        }
      }
    }))
    if (typeof onClick === 'function') onClick()

    // Métricas
    sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel, match)
  }

  render () {
    const {
      time,
      timezone,
      homeTeam,
      awayTeam,
      venue,
      isFocused,
      status,
      scheduledAt,
      broadcast,
      matchProgress,
      snLeft,
      snRight,
      customClass,
      liveEvents,
      liveScore,
      lineups,
      matchId,
    } = this.props

    const { liveHomeScore, liveAwayScore, lastGoalEvent, showGoalCelebration } = this.state
    const home = homeTeam || {}
    const away = awayTeam || {}

    const homeScore = (liveScore && liveScore.homeScore !== undefined) ? liveScore.homeScore : home.score
    const awayScore = (liveScore && liveScore.awayScore !== undefined) ? liveScore.awayScore : away.score
    const showScore = homeScore !== undefined && awayScore !== undefined && (liveScore || (status && status !== matchSchedule))

    const lastEvent = this.getLastNotableEvent(liveEvents)
    const effectiveStatus = (liveScore && liveScore.matchFinished)
      ? 'COMPLETED'
      : ((status === 'FINISHED' || status === 'FINAL') ? 'COMPLETED' : status)
    const isFinished = effectiveStatus === 'COMPLETED'
    const formation = lineups && lineups.homeLineup && lineups.awayLineup &&
      lineups.homeLineup.formation && lineups.awayLineup.formation
      ? `${lineups.homeLineup.formation} | ${lineups.awayLineup.formation}`
      : null

    const dataOptions = {}
    dataOptions['data-sn-left'] = snLeft ? snLeft : null
    dataOptions['data-sn-right'] = snRight ? snRight : null

    const isInProgress = status === matchInProgress
    const displayHomeScore = isInProgress ? liveHomeScore : home.score
    const displayAwayScore = isInProgress ? liveAwayScore : away.score

    const goalNotifType = lastGoalEvent && lastGoalEvent.eventType === 'PENALTY_GOAL' ? 'penalty' : 'goal'

    return (
      <Button
        id={`card-partido-${matchId}`}
        className={
          `card-partido
          ${isFocused ? ' card-partido--focused' : ''}
          ${effectiveStatus === matchInProgress ? ' card-partido--in-progress' : ''}
          ${showGoalCelebration ? ' card-partido--goal' : ''}
          ${this.isPhase2Enabled ? 'focusable' : ''}
          ${customClass ? customClass : ''}`
        }
        tabIndex={0}
        dataOptions={dataOptions}
        onClick={this.isPhase2Enabled ? this.handleCardClick : () => {}}
      >
        {/* Time & timezone */}
        <p className='card-partido__time'>
          <Tag
            broadcast={broadcast}
            status={effectiveStatus}
            matchProgress={matchProgress}
            time={time}
            timezone={timezone}
            scheduledAt={scheduledAt}
          />
        </p>

        {/* Teams row */}
        <div className='card-partido__teams'>
          <FlagSmall
            flagUrl={home.flagUrl}
            countryName={home.name}
          />
          <span className='card-partido__vs'>
            {
              showScore
                ? Utils.cutPlayerString(`${homeScore} - ${awayScore}`, 7)
                : Utils.cutPlayerString(Translator.get('eventodeportivo_carruseletapas_ficha_texto_parrafo1', 'vs'), 7)
            }
          </span>
          <FlagSmall
            flagUrl={away.flagUrl}
            countryName={away.name}
          />
        </div>

        {/* Goal / Penalty notification */}
        {lastGoalEvent && (
          <div className={`card-partido__goal-notif card-partido__goal-notif--${goalNotifType}`}>
            <span className='card-partido__goal-notif-player'>{lastGoalEvent.playerName}</span>
            {lastGoalEvent.minute ? <span className='card-partido__goal-notif-minute'>{`${lastGoalEvent.minute}'`}</span> : null}
          </div>
        )}

        {/* Formation (when lineups confirmed and no current event) */}
        {formation && !lastEvent && !isFinished && (
          <div className='card-partido__formation-wrapper'>
            <p className='card-partido__formation'>{formation}</p>
          </div>
        )}

        {/* Venue */}
        <div className='card-partido__venue-wrapper'>
          <p className='card-partido__venue'>{Utils.cutPlayerString(venue || '', 35)}</p>
        </div>
      </Button>
    )
  }
}

export default CardPartido



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/CardPartido/index.jsx